import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        item: {},
    },
    getters: {
        items: state => state.items,
        item: state => state.item,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setItem(state, item) {
            state.item = item;
        }
    },
    actions: {        
        async store({ commit }, payload) {
            const response = await http.post('freeradius/replies', payload);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`freeradius/replies/${id}`);

            return response;
        }
    }
}